import React, { Component } from "react";

import { Login } from "../../api/Auth"
import { inject } from "mobx-react";
import { translate } from "../../dictionaries";

@inject(stores => ({
    AuthorizationStore: stores.rootStore.Authorization,
})
)

class Auth extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            name: null,
            password: null,
            nameError: null,
            passwordError: null
        };
    }

    post = async () => {
        this.setState({
            loading: true,
            nameError: null,
            passwordError: null
        });

        const model = {
            Name: this.state.name,
            Password: this.state.password
        };

        const resp = await Login(model);

        if (resp.status === 400) {
            const json = await resp.json();

            Object.keys(json).forEach((key) => {
                if (key === "Name") {
                    this.setState({
                        nameError: json[key][0]
                    })
                }

                if (key === "Password") {
                    this.setState({
                        passwordError: json[key][0]
                    })
                }
            });
        } else {
            const json = await resp.json();

            this.props.AuthorizationStore.setAuthorize(true, json.token);
            alert(translate('common.auth'));

            window.location.href = window.location.origin;
        }

        this.setState({
            loading: false,
        });
    };

    onChangeName = (e) => {
        this.setState({
            name: e.currentTarget.value
        })
    };

    onChangePassword = (e) => {
        this.setState({
            password: e.currentTarget.value
        })
    };

    render() {
        return (
            <>
                {
                    this.state.loading &&
                    <div>
                        <div id="overlay">
                            <div className={"circle"}>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.loading &&
                    <div>
                        {
                            !!this.state.nameError &&
                            <p>
                                <span style={{ color: "red" }}>
                                    {this.state.nameError}
                                </span>
                            </p>
                        }
                        <p>
                            <input onChange={this.onChangeName} value={this.state.name} placeholder={translate('common.login')} />
                        </p>
                        {
                            !!this.state.passwordError &&
                            <p>
                                <span style={{ color: "red" }}>
                                    {this.state.passwordError}
                                </span>
                            </p>
                        }
                        <p>
                            <input onChange={this.onChangePassword} value={this.state.password} placeholder={translate('common.password')} />
                        </p>
                        <p>
                            <button onClick={this.post}>
                                {translate('common.sign')}
                            </button>
                        </p>
                    </div>
                }
            </>
        )
    }
}

export default Auth;